import icons from '@/assets/icons'
import dayjs from 'dayjs'
import IconWin from './icon-win.png'
import IconMate from './icon-mate.png'
import IconLoss from './icon-loss.png'
import { Session } from '@/services/types/history'
import { HTMLAttributes } from 'react'
import './index.less'

type GameItemProps = HTMLAttributes<HTMLDivElement> & { game: Session; onClick: () => void }
const GameItem = ({ game, onClick }: GameItemProps) => {
  const statusToTextMap: any = {
    MATE: {
      BLACK: '和棋',
      RED: '和棋',
    },
    BWIN: {
      BLACK: '黑胜',
      RED: '红负',
    },
    RWIN: {
      BLACK: '黑负',
      RED: '红胜',
    },
  }
  const iconToTextMap: any = {
    MATE: {
      BLACK: IconMate,
      RED: IconMate,
    },
    BWIN: {
      BLACK: IconWin,
      RED: IconLoss,
    },
    RWIN: {
      BLACK: IconLoss,
      RED: IconWin,
    },
  }
  return (
    <div className="game-item hoverClass" onClick={onClick}>
      <img className="icon" src={iconToTextMap[game.status][game.user_role]} alt="" />
      <span className="status">{statusToTextMap[game.status][game.user_role]}</span>
      <div className="stepflex">
        <span className="steps">{game.total_round}</span>
        <span className="step">回合</span>
      </div>
      <span className="date">{dayjs(game.start_time * 1000).format('YYYY-MM-DD  HH:mm:ss')}</span>
      <img className="icon-right" src={icons.IconRight} alt="" />
    </div>
  )
}

export default GameItem
